import React, { useEffect, useState } from 'react';
import { makeStyles, Spinner } from '@fluentui/react-components';
import { useTeamsContext } from '../../../providers/teams-context-provider';
import { useMsal } from '@azure/msal-react';

const useStyles = makeStyles({
  containerStyle: {
    flex: 1,
    gap: '20px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const AuthEnd = () => {
  const styles = useStyles();

  const { teamsClient } = useTeamsContext();

  const [initialized, setInitialized] = useState(false);

  const { instance } = useMsal();

  useEffect(() => {
    if (initialized) {
      return;
    }

    if (!teamsClient) {
      return;
    }

    instance
      .initialize()
      .then(() => instance.handleRedirectPromise())
      .then(() => {
        setInitialized(true);
        teamsClient.authentication.notifySuccess('Authentication succeeded');
      })
      .catch((error) => {
        teamsClient.authentication.notifyFailure(JSON.stringify(error));
      });
  }, [instance, teamsClient, initialized]);

  return (
    <div className={styles.containerStyle}>
      <Spinner label="Redirection..." size="large" />
    </div>
  );
};
